import Auth from '../api/auth';

import store from '../store';

const parseErrorCode = error => {
  if (error?.response?.status === 402) {
    const data = error.response.data || {};
    store.commit('license/SET_LICENSE_BLOCKED', {
      reason: data.code || 'LICENSE_BLOCKED',
      message: data.message,
      installationIdentifier: data.installationIdentifier,
    });
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
